import { InjectionToken } from '@angular/core';

export enum CONSUMERS {
  CONSUMER_ID_WEB_BROKER = 'webbroker',
  CONSUMER_ID_EASY_TRADE = 'goalassist',
  CONSUMER_ID_ATTRADER = 'attrader',
}

export interface ConsumerType {
  consumerId: CONSUMERS;
  isEmbedded: boolean;
  features?: string;
}

export const CONSUMER_TYPE = new InjectionToken<ConsumerType>('ConsumerType');
